// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preStyle[data-v-1a6c1ad3] {\n  height: calc(100vh - 70px);\n  overflow: hidden;\n}\n.preStyle .messageCon[data-v-1a6c1ad3] {\n  background: #eee;\n}\n.preStyle pre[data-v-1a6c1ad3] {\n  max-height: calc(100vh - 280px);\n  overflow-y: auto;\n  white-space: break-spaces;\n  margin: 0;\n  padding: 0 10px;\n  line-height: 26px;\n}", ""]);
// Exports
module.exports = exports;
